import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as ClientHttp from '../../../../services/api/https/registration/client.http'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const MODAL_NAME = {
  CUSTOMER: 'CUSTOMER',
  ASSOC_CUSTOMER_LOG_OPERATOR: 'ASSOC_CUSTOMER_LOG_OPERATOR',
  ASSOC_CUSTOMER_ENTERPRISE: 'ASSOC_CUSTOMER_ENTERPRISE',
  CUSTOMER_STRETCH: 'CUSTOMER_STRETCH',
  DELIVERY_ROUTE: 'DELIVERY_ROUTE',
  LOCAL_MOVEMENT: 'LOCAL_MOVEMENT',
  NONE: 'NONE',
}

export const MENU_ITEMS_NAMES = [
  'Editar',
  'Assoc. Operador Logístico',
  'Assoc. Empresa',
  'Trechos Padrões',
  'Rota de Entrega',
]

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL: 'INITIAL',
  LOADING_CUSTOMERS: 'Carregando clientes',
}

const INITIAL_STATE = {
  newCustomer: {
    id: undefined,
    razaoSocial: '',
    nomeFantasia: '',
    cnpj: '',
    address: '',
    district: '',
    number: '',
    makeParcialReturn: false,
    actived: false,
    city_id: undefined,
    uf_id: undefined,
  },
  isLoading: true,
  loadingMessage: LOAD_MESSAGE.INITIAL,
  customers: [],
  globalFilter: '',
  modalHandler: {
    modalData: null,
    modalSelected: MODAL_NAME.NONE,
  },
  errorMessage: null,
}

export default function useCliente() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    // Helper
    function setModalSelected(modalName, modalData = null) {
      setState(prevState => {
        prevState.modalHandler.modalSelected = modalName
        prevState.modalHandler.modalData = modalData
        return { ...prevState }
      })
    }

    return {
      // Actions
      getCustomers(selectedTp) {
        ClientHttp.getClients(selectedTp)
          .then(customers =>
            setState(prevState => ({
              ...prevState,
              customers: customers,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(error =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(error),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      modalIsOpen(modalName) {
        return state.modalHandler.modalSelected === modalName
      },

      closeModal() {
        setState(prevState => {
          prevState.modalHandler.modalSelected = MODAL_NAME.NONE
          prevState.modalHandler.modalData = null
          return { ...prevState }
        })
      },

      resetState() {
        setState({ ...INITIAL_STATE })
      },

      onInit(selectedTp) {
        if (selectedTp === 0)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione o Operador Logístico' }))
        else
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.LOADING_CUSTOMERS }))
      },

      onInputFilter(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onBtnNovoCliente(selectedTp) {
        if (selectedTp === 0)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione o Operador Logístico' }))
        else setModalSelected(MODAL_NAME.CUSTOMER)
      },

      onModalClienteSave(customer) {
        setState(prevState => {
          const index = prevState.customers.findIndex(cus => cus.id === customer.id)
          if (index !== -1) prevState.customers[index] = customer
          else prevState.customers.push(customer)
          prevState.modalHandler.modalSelected = MODAL_NAME.NONE
          prevState.modalHandler.modalData = null
          return { ...prevState }
        })
      },

      onBtnExportarExcelClick(customers) {
        const colunas = [
          ['Nome Fantasia', 'CNPJ', 'Cidade', 'Endereço', 'Bairro', 'Estado', 'Ativo'],
        ]
        customers.forEach(e => {
          colunas.push([
            e.nomeFantasia,
            e.cnpj.toString(),
            e.city,
            `${e.address} - ${e.number}`,
            e.district,
            e.state,
            e.actived ? 'Sim' : 'Não',
          ])
        })

        gerarArquivoExcel('Todos os Clientes', colunas, 'clientes.xlsx')
      },

      onMenuItemClicked(item, cliente) {
        switch (item) {
          case 'Editar':
            setModalSelected(MODAL_NAME.CUSTOMER, cliente)
            break
          case 'Assoc. Operador Logístico':
            setModalSelected(MODAL_NAME.ASSOC_CUSTOMER_LOG_OPERATOR, cliente)
            break
          case 'Assoc. Empresa':
            setModalSelected(MODAL_NAME.ASSOC_CUSTOMER_ENTERPRISE, cliente)
            break
          case 'Trechos Padrões':
            setModalSelected(MODAL_NAME.CUSTOMER_STRETCH, cliente)
            break
          case 'Rota de Entrega':
            setModalSelected(MODAL_NAME.DELIVERY_ROUTE, cliente)
            break
          case 'Gerar Local Movim':
            setModalSelected(MODAL_NAME.LOCAL_MOVEMENT, cliente)
            break
          default:
            break
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
